import React from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";

function Question(props) {
  return (
    <div
      className={
        props.color
          ? "services_question bg_color p-100"
          : "services_question p-100"
      }
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
            <div className="example" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Why should doctors and healthcare practitioners invest in
                  mobile app development?
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Building dedicated healthcare apps empowers practitioners to
                    integrate cutting-edge solutions, streamline patient care,
                    automate processes, and enhance healthcare delivery systems.
                    It improves patient engagement, remote consultations,
                    personalized healthcare services, and efficient medical
                    information management.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  How can mobile healthcare digital solutions benefit patients
                  and improve their experience?
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Healthcare mobile apps offer convenient appointment
                    scheduling and complete access to vital health information.
                    Further, it involves personalized wellness and fitness
                    tracking, symptom monitoring, medication management, mental
                    health support, and valuable educational resources. Digital
                    healthcare solutions enable patients to take control of
                    their health, receive timely care, and enhance their overall
                    well-being.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  Can mobile healthcare apps integrate with electronic health
                  record (EHR) systems?
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Yes, mobile healthcare apps can integrate with existing EHR
                    systems. The integration enables seamless sharing and access
                    to patient medical records, diagnoses, medications, test
                    results, and other essential data. This integration
                    streamlines clinical workflows, enhances care coordination,
                    and ensures healthcare providers have up-to-date patient
                    information at their fingertips.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  How much does healthcare software development cost?
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    The scale of healthcare digital solutions is quite wide as
                    compared to regular apps and software. This software
                    includes functionalities like scheduling patient
                    appointments, storing and retrieving digital medical
                    records, organizing staff schedules, and generating
                    invoices. It also facilitates secure communication via
                    encrypted chat and in-app messaging. So, developing such a
                    system typically requires an investment ranging from
                    $100,000 to $300,000 on average.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  Does TekRevol Offer Support and Maintenance for Digital
                  Healthcare Solutions?
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    Yes, being a trusted provider of digital health services,
                    TekRevol offers complete maintenance and support even after
                    the deployment of any healthcare solution. Whether, it's
                    your integrated healthcare system, healthcare software, or a
                    healthcare mobile app, you can have our professional
                    assistance at every step of the way.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Question;
